import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import Title from '../../sharedcomponents/title/title';
import CustomTabs from '../../sharedcomponents/customTabs/customTabs';
import { Downgraded, useState } from '@hookstate/core';
// import Participants from './../participants';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ShowRosters from './showRoster';
import ManageRosters from './manageRoster'
import Participants from '../EventParticipants/participants';

const Rosters = () => {
    const tabValue = useState(0);
    const loading = useState(false);
    const eventInfo = useState(null);
    const collectionTabs = useState([
        {
            label: 'Manage Rosters',
            value: 0,
            component: ManageRosters,
            data: [],
        },
        {
            label: 'View Rosters',
            value: 1,
            component: ShowRosters,
            data: [],
        },
    ]);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const handleChange = (value) => {
        tabValue.set(value);
    };

    useEffect(() => {
        const geventInfo = Helper.getStorage('eventInfo');
        eventInfo.set(geventInfo);

        // get participants of event
        //getParticipants();
    }, []);

    const getParticipants = () => {
        // const eventInfo = Helper.getStorage('eventInfo');
        if (eventInfo.get()) {
            loading.set(true);
            ApiHelper.get(
                APIURLConstants.GET_EVENT_PARTICIPANTS(eventInfo.get().eventID)
            )
                .then((res) => {
                    if (res.data) {
                        loading.set(false);
                        if (res.data.length > 0) {
                            collectionTabs[0].set({
                                label: 'Participants',
                                value: 1,
                                component: Participants,
                                data: res.data,
                            });
                        } else {
                            collectionTabs[0].data.set([]);
                        }
                    }
                })
                .catch((err) => {
                    loading.set(false);
                    //... Check if user's session has expired
                    if (err.response && err.response.status === 401) {
                        console.log(err);
                    }
                });
        }
    };

    return (
        <Box
            sx={{
                // p: 2,
                width: '100%',
            }}>
            <Box className="contentBox">
                <Title
                    title={'Rosters'}
                    sx={{
                        ml: 0,
                    }}
                    px={0}
                /> 
                <CustomTabs
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getParticipants={getParticipants}
                    value={tabValue.get()}
                    handleChange={handleChange}
                    data={collectionTabs.attach(Downgraded).get()}
                    removeMargin={true}
                />
                
            </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.ROSTERS,
        component: Rosters,
    },
    name: 'Rosters',
};
